export default "__VITE_ASSET__lKw3eLw$__"